import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getRoutesProgress } from 'src/api';
import { RoutesHeader, RoutesSection, RoutesSimpleSection } from './';
import styles from './Routes.module.sass';

export const Routes = () => {
  const learningPaths = useSelector((state) => state.get('school').get('tabLp'))?.toJS() || {};
  const isLogged = useSelector((state) => state.get('header').get('isLogged')) || false;
  const hasMultipleLearningPaths: boolean = learningPaths.length > 1;

  const [routesProgress, setRoutesProgress] = useState({});

  useEffect(() => {
    if (isLogged) {
      const schoolSlug = window.location.pathname.replaceAll('/escuela/', '');
      getRoutesProgress(schoolSlug)
        .then((res) => setRoutesProgress(res.data))
        .catch((err) => {
          throw new Error('::ERROR::SCHOOL__ROUTES', { cause: err });
        });
    }
  }, [isLogged]);

  return (
    <div className={styles.Routes} id="Routes">
      <div className="u-wrapper">
        <RoutesHeader showTabs={hasMultipleLearningPaths} description={learningPaths?.[0]?.description} />
        {hasMultipleLearningPaths ? (
          learningPaths?.map((item, index: number) => (
            <RoutesSection key={`lsSection-${index}`} routesProgress={routesProgress} {...item} index={index} />
          ))
        ) : (
          <RoutesSimpleSection routesProgress={routesProgress} learningPath={learningPaths[0]} />
        )}
      </div>
    </div>
  );
};
